"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _datePicker = require("@jsluna/date-picker");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _form = require("@jsluna/form");

var _moment = _interopRequireDefault(require("moment"));

var _constants = require("../utils/constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var SingleDateTimePicker = function SingleDateTimePicker(_ref) {
  var id = _ref.id,
      valueChanged = _ref.valueChanged,
      datePickerLabel = _ref.datePickerLabel,
      datePickerProps = _ref.datePickerProps,
      defaultTime = _ref.defaultTime,
      disablePicker = _ref.disablePicker,
      errorMsg = _ref.errorMsg,
      fullWidth = _ref.fullWidth,
      hasError = _ref.hasError,
      hideAll = _ref.hideAll,
      hideTime = _ref.hideTime,
      isOutsideRange = _ref.isOutsideRange,
      pickerClass = _ref.pickerClass,
      selectedDate = _ref.selectedDate;

  var _useState = (0, _react.useState)(selectedDate),
      date = _useState[0],
      setDate = _useState[1];

  var _useState2 = (0, _react.useState)(defaultTime),
      time = _useState2[0],
      setTime = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      dateFocused = _useState3[0],
      setDateFocused = _useState3[1];

  var handleDateChange = function handleDateChange(newDate) {
    newDate.hours(time.substring(0, 2)).minutes(time.substring(3, 5)).seconds(0);
    valueChanged(newDate);
    setDate(newDate);
  };

  var handleTimeChange = function handleTimeChange(event) {
    var hour = event.target.value.substring(0, 2);
    var minute = event.target.value.substring(3, 5);
    var value = event.target.value;
    var currentDate = date;

    if (currentDate === null) {
      currentDate = (0, _moment.default)();
    }

    currentDate = currentDate.hours(hour).minutes(minute).seconds(0);
    setTime(value);
    valueChanged(currentDate);
  };

  var getTimeSlots = function getTimeSlots() {
    var start = (0, _moment.default)('2000-1-28T00:00:00', 'YYYY-MM-DD hh:mm a');
    var end = (0, _moment.default)('2000-1-28T23:45:00', 'YYYY-MM-DD hh:mm a');
    start.minutes(Math.ceil(start.minutes() / 30) * 30);
    var result = [];
    var current = (0, _moment.default)(start);

    while (current <= end) {
      result.push({
        value: current.format('HH:mm'),
        label: current.format('HH:mm')
      });
      current.add(30, 'minutes');
    }

    return result;
  };

  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, datePickerLabel && /*#__PURE__*/_react.default.createElement(_form.Label, {
    htmlFor: id
  }, datePickerLabel)), /*#__PURE__*/_react.default.createElement("div", {
    className: "DateTimePicker display-inline-block " + ((hasError || errorMsg) && 'error') + " " + (hideAll ? 'hidden' : '') + " " + (fullWidth && 'DateTimePicker__FullWidth') + " " + pickerClass
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "DateTimePicker__Item " + (fullWidth && 'DateTimePicker__FullWidth')
  }, /*#__PURE__*/_react.default.createElement(_datePicker.SingleDatePicker, _extends({
    id: id + "-SingleDatePicker",
    readOnly: true,
    disabled: disablePicker,
    placeholder: _constants.DEFAULT_PLACEHOLDER_DATE_FORMAT,
    displayFormat: _constants.DEFAULT_PLACEHOLDER_DATE_FORMAT,
    date: date,
    focused: dateFocused,
    onDateChange: function onDateChange(newDate) {
      handleDateChange(newDate);
    },
    onFocusChange: function onFocusChange(_ref2) {
      var focused = _ref2.focused;
      setDateFocused(focused);
    },
    isOutsideRange: isOutsideRange
  }, datePickerProps))), /*#__PURE__*/_react.default.createElement("div", {
    className: "DateTimePicker__Item TimeSelector__Parent " + (hideTime ? 'hidden' : '')
  }, /*#__PURE__*/_react.default.createElement(_form.Select, {
    id: id + "-Select",
    placeholder: "",
    disabled: disablePicker,
    className: fullWidth ? 'TimeSelector TimeSelector__FullWidth' : 'TimeSelector',
    options: getTimeSlots(),
    onChange: handleTimeChange,
    value: time
  }))), hasError && /*#__PURE__*/_react.default.createElement("div", {
    className: "ln-c-form-group has-error"
  }, /*#__PURE__*/_react.default.createElement(_form.FieldInfo, {
    error: true
  }, errorMsg)));
};

SingleDateTimePicker.propTypes = {
  id: _propTypes.default.string,
  errorMsg: _propTypes.default.string,
  valueChanged: _propTypes.default.func.isRequired,
  defaultTime: _propTypes.default.string,
  datePickerLabel: _propTypes.default.string,
  hideAll: _propTypes.default.bool,
  selectedDate: _propTypes.default.object,
  hideTime: _propTypes.default.bool,
  disablePicker: _propTypes.default.bool,
  hasError: _propTypes.default.bool,
  fullWidth: _propTypes.default.bool,
  isOutsideRange: _propTypes.default.func,
  datePickerProps: _propTypes.default.object,
  pickerClass: _propTypes.default.string
};
SingleDateTimePicker.defaultProps = {
  id: 'SingleDateTimePicker',
  defaultTime: '00:00',
  errorMsg: '',
  hideAll: false,
  selectedDate: null,
  hideTime: false,
  disablePicker: false,
  hasError: false,
  datePickerLabel: null,
  fullWidth: false,
  isOutsideRange: function isOutsideRange() {},
  datePickerProps: {},
  pickerClass: ''
};
var _default = SingleDateTimePicker;
exports.default = _default;